module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <!-- *ngIf=\"product.active\" -->\n    <div class=\"col-lg-4\" *ngFor=\"let product of products\">\n      <app-product-card [product]=\"product\" [user]=\"user\"></app-product-card>\n    </div>\n  </div>\n        \n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/products/product-list/product-list.component.html
// module id = ./src/app/components/products/product-list/product-list.component.html
// module chunks = main